export enum ViewTypeEnum {
  GRID = 'grid',
  LIST = 'list'
}
